import React, { useState, useEffect } from "react";
import { Row, Col, Card, message, Divider, Table, Input, Space, Tag } from "antd";
import {
  SearchOutlined,
  BarChartOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";

export const TermosRelatorioDetalhes = () => {
  const { id_termo, id_filial } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  // ID ALTERAÇÃO
  const [search, setSearch] = useState("");

  // DADOS
  const [termo, setTermo] = useState({});
  const [filial, setFilial] = useState({});

  useEffect(() => {
    if (id_termo > 0) {
      carregarTermo(id_termo);
      listarRelatorioDetalhes(id_termo, id_filial);
    }
  }, [id_termo]);

  // CARREGAR
  const carregarTermo = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/termos/carregar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setTermo(response);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarRelatorioDetalhes = async (id, filial) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/termos/relatorio_detalhes?filial=${filial}&termo=${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;

      setFilial(response?.filial);
      setDados(response?.relatorio);
    } else {
      navigate("/termos/cadastro");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const renderStatus = (status) => {
    if (status === 1) {
      return <Tag color="green">Confirmado</Tag>;
    } else if (status === -1) {
      return <Tag color="default">Deixar para depois</Tag>;
    } else {
      return <Tag color="orange">Não confirmado</Tag>;
    }
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Colaborador",
      dataIndex: "colaborador",
      sorter: (a, b) => a.colaborador?.localeCompare(b.colaborador),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, e) => renderStatus(e?.status),
      sorter: (a, b) => (a.status ?? 0)?.toString()?.localeCompare((b.status ?? 0)?.toString()),
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter((val) => val.colaborador?.toLowerCase().includes(pesquisar.toLowerCase()));
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Configurações" onClickBack={() => navigate(`/termos/relatorio/${id_termo}`)} />
            <HeaderTitle
              title="Relatório Termos de Ciência Detalhes"
              subtitle={`${termo?.descricao ?? ""} / ${filial?.descricao}`}
              icon={<BarChartOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
              </Space>
              <Divider />
              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
